/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgGitSwitch = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M6 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4zM2 6a4 4 0 1 1 5 3.874V19h5v2H5V9.874A4.002 4.002 0 0 1 2 6zm10-3h7v11.126A4.002 4.002 0 0 1 18 22a4 4 0 0 1-1-7.874V5h-5zm6 13a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgGitSwitch as GitSwitch };
